module.exports = __webpack_public_path__ + "img/dialogLeft.a37d6fe6.png";